import { GetServerSideProps } from 'next';
import React from 'react';
import SingleBlogContent from '@/components/landing/blog/SingleBlogContent';
import { useRouter } from 'next/router';
import APIServices from '@/apiUtils/APIServices';
import ErrorPage from '@/pages/404/index';
import SEO from '@/components/landing/seo';
import LandingLayout from '@/components/landing/home/LandingLayout';

function SingleBlog(props) {
  const router = useRouter();
  if (props?.data === null) {
    return <ErrorPage />;
  }

  const schemas = !!props?.data
    ? `{
    "@context": "https://schema.org/",
    "@type": "Article",
    "mainEntityOfPage":
      {"@type":"WebPage",
      "@id": "${process.env.NEXT_PUBLIC_SITE_URL}blog/${props?.data?.slug}"},
      "headline":"${props?.data?.title}",
      "url": "${process.env.NEXT_PUBLIC_SITE_URL}blog/${props?.data?.slug}",
      "dateModified":"${props?.data?.publish}",
      "datePublished":"${props?.data?.publish}",
      "author": 
          {"@type":"Person",
          "name":"${props?.data?.author?.name}"
          },
      "publisher": 
        {"@type": "Organization",
        "name": "Learnsic",
        "logo": 
          {"@type": "ImageObject",
          "url": "${process.env.NEXT_PUBLIC_SITE_URL}/studyinfo.png"
          }
        },
      "image": {
        "@type":"ImageObject",
        "name":"${props.data?.title}",
        "url":"${props.data?.photo}"
        }
      }`
    : `{}`;

  return (
    <>
      <SEO
        meta_title={props.data?.meta_title}
        meta_description={props.data?.meta_description}
        meta_keywords={props.data?.meta_keywords}
        photo={props.data?.photo}
        schemas={schemas}
        canonical={`blog/${props.data?.slug}`}
      />
      <LandingLayout>
        <SingleBlogContent blog={props?.data} loading={router.isFallback} />
      </LandingLayout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  params: { slug },
}) => {
  const { data, success } = await new APIServices(`/blog/${slug}`).get();

  return {
    props: {
      data: success ? data : null,
    },
  };
};

export default SingleBlog;
